export default __webpack_public_path__ + "static/WhistleblowingSystem-1abd37f5b643baed2272f403824c7332.pdf";